import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";

export class CaseLogType extends Resource {
    public override type = 'caseLogTypes';

    @prop()
    @required()
    public code: string = "";

    @prop()
    @required()
    public name: string = "";
    
    @prop()
    public iconClass!: string;

    @prop()
    public revisionRequired: boolean = true;

    @prop()
    public isGeneric: boolean = false;

    /** JSON { fields: [...] } con el formulario a rellenar al crear un evento de este tipo */
    @prop()
    public fieldsConfiguration?: string;
}